// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/static/images/notifications/no_notifications_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/static/images/notifications/end_of_list_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications {
  font-family: "Aeonik", sans-serif;
  border: 1px solid #E8E9F0;
  height: 97vh;
  overflow: auto;
  overflow-x: hidden;
  background-color: #FFF;
}
.notifications-header {
  height: 30px;
  line-height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  text-align: center;
  border-bottom: 1px solid #E8E9F0;
  padding: 22px;
  font-size: 11px;
  letter-spacing: 0;
  color: #002E33;
  font-weight: 700;
}
.notifications-title {
  font-size: 14px;
  width: 30%;
  text-align: left;
}
.notifications-read {
  width: 30%;
  border: 1px solid gainsboro;
  border-radius: 0 50px 50px 0;
}
.notifications-unread {
  margin-left: 16px;
  width: 30%;
  border: 1px solid gainsboro;
  border-radius: 50px 0 0 50px;
}
.notifications-actions {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  width: 70%;
  color: #697588;
}
.notifications-actions-text {
  overflow: hidden;
}
.notifications-actions--active {
  color: #002E33;
  background-color: #F5F6F9;
}
.notifications-action {
  -webkit-transition: all 100ms linear;
  transition: all 100ms linear;
  min-width: 50px;
}
.notifications-markAllAsRead {
  line-height: 15px;
  -ms-flex-item-align: center;
      align-self: center;
}

.notifications-modal__content-container {
  background-color: #FFF;
  display: inline-block;
  position: fixed;
  width: 45%;
  min-width: 600px;
  right: 0;
  top: 40px;
  height: calc(100% - 40px);
  z-index: 30;
  -webkit-box-shadow: 1px 1px 12px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 1px 1px 12px 0 rgba(38, 40, 47, 0.15);
  text-transform: none;
  text-transform: initial;
  letter-spacing: normal;
  letter-spacing: initial;
  line-height: normal;
  line-height: initial;
  overflow-y: scroll;
}
.notifications-modal__deleted-banner {
  line-height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  text-align: left;
  border-bottom: 1px solid #E8E9F0;
  padding: 15px 15px 15px 32px;
  font-size: 14px;
  font-weight: 500;
  color: #697588;
}
.notifications-modal__empty-list__image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: bottom;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 35vh;
}
.notifications-modal__empty-list__text {
  color: #002E33;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  line-height: 1.2;
  margin-top: 10px;
  margin-bottom: 50px;
  text-align: center;
}
.notifications-modal__end-of-list__image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 110px;
  margin-top: 15px;
}
.notifications-modal__end-of-list__text {
  color: #002E33;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  line-height: 1.2;
  margin-top: 5px;
  margin-bottom: 50px;
  text-align: center;
}
.notifications-modal__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  text-align: center;
  border-bottom: 1px solid #E8E9F0;
  padding: 22px 22px 0px;
  font-size: 11px;
  letter-spacing: 0;
  color: #002E33;
  font-weight: 700;
}
.notifications-modal__header-title {
  font-size: 14px;
  -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
  margin-bottom: 24px;
  text-align: left;
}
.notifications-modal__header-actions {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
  color: #002E33;
  padding-bottom: 16px;
}
.notifications-modal__header-filter {
  -ms-flex-preferred-size: 70%;
      flex-basis: 70%;
  text-align: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.notifications-modal__header-filter-all {
  -ms-flex-preferred-size: 10%;
      flex-basis: 10%;
}
.notifications-modal__header-filter-all.selected {
  color: #002E33;
}
.notifications-modal__header-filter-all.selected span {
  border-bottom: solid 1px #01FF94;
  padding-bottom: 16px;
}
.notifications-modal__header-filter-deleted.selected {
  color: #002E33;
}
.notifications-modal__header-filter-deleted.selected span {
  border-bottom: solid 1px #01FF94;
  padding-bottom: 16px;
}
.notifications-modal__header-delete {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 30%;
      flex-basis: 30%;
  text-align: right;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.hidden {
  display: none;
}

@media screen and (max-width: 1024px) {
  .notifications-modal {
    width: calc(100% - 40px);
    min-width: 0;
    min-width: initial;
    right: 20px;
    margin-left: auto;
    margin-right: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/notifications/NotificationsModal.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAIA;EACI,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,sBCFI;ADDR;AAII;EACI,YAAA;EACA,iBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,2BAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnBO;EDoBP,gBAAA;AAFR;AAII;EACI,eAAA;EACA,UAAA;EACA,gBAAA;AAFR;AAII;EACI,UAAA;EACA,2BAAA;EACA,4BAAA;AAFR;AAII;EACI,iBAAA;EACA,UAAA;EACA,2BAAA;EACA,4BAAA;AAFR;AAII;EACI,eAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,qBAAA;MAAA,kBAAA;UAAA,yBAAA;EACA,UAAA;EACA,cCQC;ADVT;AAGQ;EACI,gBAAA;AADZ;AAGQ;EACI,cChDG;EDiDH,yBCOH;ADRT;AAII;EACI,oCAAA;EAAA,4BAAA;EACA,eAAA;AAFR;AAII;EACI,iBAAA;EACA,2BAAA;MAAA,kBAAA;AAFR;;AAQI;EACI,sBC3DA;ED4DA,qBAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,yDAAA;UAAA,iDAAA;EACA,oBAAA;EAAA,uBAAA;EACA,sBAAA;EAAA,uBAAA;EACA,mBAAA;EAAA,oBAAA;EACA,kBAAA;AALR;AAQI;EACI,iBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,mBAAA;MAAA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,cCxCC;ADkCT;AAUQ;EACI,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,YAAA;AARZ;AAWQ;EACI,cCxGG;EDyGH,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AATZ;AAcQ;EACI,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,aAAA;EACA,gBAAA;AAZZ;AAeQ;EACI,cC/HG;EDgIH,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAbZ;AAiBI;EACI,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,2BAAA;EACA,mBAAA;MAAA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCpJO;EDqJP,gBAAA;AAfR;AAiBQ;EACI,eAAA;EACA,6BAAA;MAAA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAfZ;AAkBQ;EACI,eAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EAEA,6BAAA;MAAA,gBAAA;EACA,cCnKG;EDoKH,oBAAA;AAjBZ;AAoBQ;EACI,4BAAA;MAAA,eAAA;EACA,gBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;AAlBZ;AAoBY;EACI,4BAAA;MAAA,eAAA;AAlBhB;AAoBgB;EACI,cChLL;AD8Jf;AAmBoB;EACI,gCAAA;EACA,oBAAA;AAjBxB;AAwBgB;EACI,cC3LL;ADqKf;AAuBoB;EACI,gCAAA;EACA,oBAAA;AArBxB;AA2BQ;EACI,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;MAAA,eAAA;EACA,iBAAA;EACA,qBAAA;MAAA,kBAAA;UAAA,yBAAA;AAzBZ;;AA8BA;EACI,aAAA;AA3BJ;;AA8BA;EACI;IACE,wBAAA;IACA,YAAA;IAAA,kBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EA3BJ;AACF","sourcesContent":["@import \"../../Global/Layout.scss\";\n@import \"../../Global/Colors.scss\";\n\n// The header and container\n.notifications {\n    font-family: \"Aeonik\",sans-serif;\n    border: 1px solid $Gray30;\n    height: 97vh;\n    overflow: auto;\n    overflow-x: hidden;\n    background-color: $White;\n    &-header {\n        height: 30px;\n        line-height: 30px;\n        display: flex;\n        justify-content: flex-start;\n        text-align: center;\n        border-bottom: 1px solid $Gray30;\n        padding: 22px;\n        font-size: 11px;\n        letter-spacing: 0;\n        color: $DeepSeaGreen;\n        font-weight: 700;\n    }\n    &-title {\n        font-size: 14px;\n        width: 30%;\n        text-align: left;\n    }\n    &-read {\n        width: 30%;\n        border: 1px solid gainsboro;\n        border-radius: 0 50px 50px 0;\n    }\n    &-unread {\n        margin-left: 16px;\n        width: 30%;\n        border: 1px solid gainsboro;\n        border-radius: 50px 0 0 50px;\n    }\n    &-actions {\n        cursor: pointer;\n        display: flex;\n        justify-content: flex-end;\n        width: 70%;\n        color: $Gray90;\n        &-text {\n            overflow: hidden;\n        }\n        &--active {\n            color: $DeepSeaGreen;\n            background-color: $Gray20;\n        }\n    }\n    &-action {\n        transition: all 100ms linear;\n        min-width: 50px;\n    }\n    &-markAllAsRead {\n        line-height: 15px;\n        align-self: center;\n    }\n}\n\n.notifications-modal {\n\n    &__content-container{\n        background-color: $White;\n        display: inline-block;\n        position: fixed;\n        width: 45%;\n        min-width: 600px;\n        right: 0;\n        top: 40px;\n        height: calc(100% - 40px);\n        z-index: 30;\n        box-shadow: 1px 1px 12px 0 rgba($Gray200, 0.15);\n        text-transform: initial;\n        letter-spacing: initial;\n        line-height: initial;\n        overflow-y: scroll;\n    }\n\n    &__deleted-banner{\n        line-height: 30px;\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        text-align: left;\n        border-bottom: 1px solid $Gray30;\n        padding: 15px 15px 15px 32px;\n        font-size: 14px;\n        font-weight: 500;\n        color: $Gray90;\n    }\n\n    &__empty-list{\n        &__image{\n            background-image: url('/src/static/images/notifications/no_notifications_icon.svg');\n            background-repeat: no-repeat;\n            background-position:bottom;\n            display: flex;\n            height: 35vh;\n        }\n\n        &__text{\n            color: $DeepSeaGreen;\n            display: flex;\n            font-size: 16px;\n            font-weight: 700;\n            justify-content: center;\n            line-height: 1.2;\n            margin-top: 10px;\n            margin-bottom: 50px;\n            text-align: center;\n        }\n    }\n\n    &__end-of-list{\n        &__image{\n            background-image: url('/src/static/images/notifications/end_of_list_icon.svg');\n            background-repeat: no-repeat;\n            background-position: center;\n            display: flex;\n            height: 110px;\n            margin-top: 15px;\n        }\n\n        &__text{\n            color: $DeepSeaGreen;\n            display: flex;\n            font-size: 16px;\n            font-weight: 700;\n            justify-content: center;\n            line-height: 1.2;\n            margin-top: 5px;\n            margin-bottom: 50px;\n            text-align: center;\n        }\n    }\n\n    &__header{\n        display: flex;\n        justify-content: flex-start;\n        flex-wrap: wrap;\n        text-align: center;\n        border-bottom: 1px solid $Gray30;\n        padding: 22px 22px 0px;\n        font-size: 11px;\n        letter-spacing: 0;\n        color: $DeepSeaGreen;\n        font-weight: 700;\n\n        &-title{\n            font-size: 14px;\n            flex-basis: 100%;\n            margin-bottom: 24px;\n            text-align: left;\n        }\n\n        &-actions{\n            cursor: pointer;\n            display: flex;\n            // line-height: 20px;\n            flex-basis: 100%;\n            color: $DeepSeaGreen;\n            padding-bottom: 16px;\n        }\n\n        &-filter{\n            flex-basis: 70%;\n            text-align: left;\n            display: flex;\n\n            &-all{\n                flex-basis: 10%;\n\n                &.selected {\n                    color: $DeepSeaGreen;\n                    & span{\n                        border-bottom: solid 1px $ElectricGreen;\n                        padding-bottom: 16px;\n                    }\n                }\n            }\n\n            &-deleted{\n\n                &.selected {\n                    color: $DeepSeaGreen;\n                    & span{\n                        border-bottom: solid 1px $ElectricGreen;\n                        padding-bottom: 16px;\n                    }\n                }\n            }\n        }\n\n        &-delete{\n            display: flex;\n            flex-basis: 30%;\n            text-align: end;\n            justify-content: flex-end;\n        }\n    }\n}\n\n.hidden {\n    display: none;\n}\n\n@media screen and (max-width: $pageWidthOneColumn) {\n    .notifications-modal {\n      width: calc(100% - 40px);\n      min-width: unset;\n      right: 20px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n}\n\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
